/*
 * Created on TUE 27 April 2021
 *
 * Copyright (c) 2021 Flix
 */
import { combineReducers } from "redux";
import profileReducer from "./profile";
import notificationReducer from "./notification";
import parkingreducer from './parkingdetails';

const rootReducer = combineReducers({
  Notification: notificationReducer,
  Profile: profileReducer,
  Parkingdetails: parkingreducer,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
